import React, { useState } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useEffect } from "react";
import useFetching from "../../utils/Fetching";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import styled from "styled-components";
import AddDocumentDialog from "./AddDocumentDialog";
import DeleteDocumentDialog from "./DeleteDocumentDialog";

const PdfTable = () => {
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { adminShowPDF, adminUpdatePDF, adminDeletePDF } = useFetching();

  const showPDF = async () => {
    try {
      setLoading(true);
      const response = await adminShowPDF();

      const formattedData = response.map((item) => {
        const lastModifiedDate = new Date(item.lastModified);
        const formattedDate = lastModifiedDate.toLocaleDateString();

        return {
          ...item,
          lastModified: formattedDate,
          lastModifiedTime: lastModifiedDate.toLocaleTimeString(),
        };
      });

      setFileData(formattedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Fehler beim Laden der PDF-Daten:", error);
    }
  };

  useEffect(() => {
    showPDF();
  }, []);

  const handleFileChange = async (index, event) => {
    const file = event.target.files[0];
    if (file) {
      const newFileData = [
        ...fileData.map((obj) => {
          return { ...obj };
        }),
      ];
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString("de-DE");
      const formattedTime = currentDate.toLocaleTimeString("de-DE");

      const name = newFileData[index].fileName;
      const updated = await adminUpdatePDF(file, name);
      if (Object.keys(updated).length > 0) {
        newFileData[index] = {
          ...updated,
          lastModified: formattedDate,
          lastModifiedTime: formattedTime,
        };
        setFileData(newFileData);
      }
    }
  };

  const handleNameClick = (data) => {
    if (data.fileData) {
      const dataUrl = data.fileData.startsWith("data:application/pdf;base64,")
        ? encodeURI(data.fileData)
        : "data:application/pdf;base64," + encodeURI(data.fileData);
      window.open(dataUrl, "_blank");
    }
  };

  const handleUpload = () => {
    showPDF();
  };

  const handleDelete = async (data) => {
    await adminDeletePDF(data.fileName);
    showPDF();
  };

  return (
    <TableContainer
      className={`container-table ${loading ? "loading" : ""}`}
      component={Paper}
    >
      {fileData && !loading && (
        <Table className="table">
          <caption>
            <AddDocumentDialog
              buttonText="Dokument hinzufügen"
              onSubmit={handleUpload}
            />
          </caption>
          <TableHead>
            <TableRow>
              <TableCell>Datei</TableCell>
              <TableCell>Upload-Name</TableCell>
              <TableCell>Zuletzt hochgeladen</TableCell>
              <TableCell align="right">Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fileData.map((data, index) => (
              <TableRow key={index}>
                <TableCell>
                  <span
                    onClick={() => handleNameClick(data)}
                    className="underline-pointer"
                  >
                    {data.fileName}
                  </span>
                </TableCell>
                <TableCell>
                  <span>{data.uploadName && data.uploadName}</span>
                </TableCell>
                <TableCell>
                  <Tooltip title={data.lastModifiedTime}>
                    <span>{data.lastModified}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="right">
                  <Button
                    component="label"
                    role={undefined}
                    variant="outlined"
                    startIcon={<UploadFileIcon />}
                    sx={{ mr: 1 }}
                  >
                    Ersetzen
                    <VisuallyHiddenInput
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(index, e)}
                    />
                  </Button>
                  <DeleteDocumentDialog
                    document={data}
                    onSubmit={() => handleDelete(data)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {loading && <div className="loading-spinner small"></div>}
    </TableContainer>
  );
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default PdfTable;
